/* Usage

***** wrapper
// Context
import ContextProvider from 'src/@core/context';

return (
  <ContextProvider>
    {children...}
  </ContextProvider>
)

***** injection
// context
import { useGlobalContext } from 'src/context';

const globalContext = useGlobalContext() //as IGlobalProps

*/

import React from 'react'

import GlobalProvider, { useGlobalContext } from './useGlobalContext'
import StreamContext, { useStreamContext } from './useStreamContext'

function ContextProvider(props: any) {
  return (
    <GlobalProvider>
      <StreamContext>
        {props.children}
      </StreamContext>
    </GlobalProvider>
  )
}

export { useGlobalContext, useStreamContext }
export default ContextProvider
